export default {
    'FETCH_OFFICES' (state, data) {
        state.offices = data;
  }
}